export default __webpack_public_path__ + "static/main-section-backgroun-00de763be3506ade9abe5fed8befcea5.png";